import { useMemo } from 'react';
import Fuse from 'fuse.js';
import { useDevicesByType } from 'app/agriculture/queries/devices/useDevicesByType';
import { useSnapshots } from 'app/agriculture/queries/snapshots/useSnapshots';
import { useDailyRainfallValue } from 'app/agriculture/hooks/useDailyRainfall/useDailyRainfallValue';

export function useWeatherStationResults(textFilter: string) {
    const weatherStations = useDevicesByType('Weather Station');
    const weatherSnapshots = useSnapshots({
        snapshotType: 'Weather',
    });
    const { getDailyRainfallValue } = useDailyRainfallValue();

    const fuse = useMemo(
        () =>
            new Fuse(Array.from(weatherStations.values()), {
                keys: [
                    { name: 'name', weight: 1 },
                    { name: 'externalId', weight: 0.2 },
                    {
                        name: 'temp',
                        weight: 0.5,
                        getFn: (device) =>
                            `${weatherSnapshots.get(device.id)?.temperature?.toFixed(1) ?? '--'}°C`,
                    },
                    {
                        name: 'rain',
                        weight: 0.5,
                        getFn: (device) =>
                            `${getDailyRainfallValue({ deviceId: device.id })?.toFixed(1) ?? '--'}mm`,
                    },
                ],
            }),
        [weatherStations, weatherSnapshots, getDailyRainfallValue],
    );

    return useMemo(
        () =>
            !textFilter
                ? Array.from(weatherStations.values())
                : fuse.search(textFilter).map(({ item }) => item),
        [textFilter, fuse, weatherStations],
    );
}
